import { createContext, useContext } from "react";

import type { ReactNode } from "react";

export type AuthenticationState = "checking" | "authenticated" | "anonymous";

const PUBLIC_EXACT_ROUTES = new Set([
  "/signup",
  "/account/new",
  "/termos",
  "/auth/apple/callback",
]);

const PUBLIC_ROUTE_PREFIXES = [
  "/login",
  "/accept-invite",
  "/change-password",
  "/comunicado",
] as const;

export function isPublicApplicationRoute(pathname: string): boolean {
  return PUBLIC_EXACT_ROUTES.has(pathname) || PUBLIC_ROUTE_PREFIXES.some((route) => (
    pathname === route || pathname.startsWith(`${route}/`)
  ));
}

export function canRenderApplicationPage(
  state: AuthenticationState,
  isPublicRoute: boolean,
): boolean {
  return isPublicRoute || state === "authenticated";
}

const AuthenticationStateContext = createContext<AuthenticationState>("checking");

export function AuthenticationStateProvider({ children, value }: { children: ReactNode; value: AuthenticationState }) {
  return <AuthenticationStateContext.Provider value={value}>{children}</AuthenticationStateContext.Provider>;
}

export function useAuthenticationState(): AuthenticationState {
  return useContext(AuthenticationStateContext);
}
